import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1 className="text-danger text-center">NO PAGE FOUND <br/> ERROR 404</h1>
        </div>
    );
};

export default NoMatch;